(function () {
    $(document).ready(function () {
        // Fix textarea rows
        $("textarea").attr("rows", 1);

        // Initialize autogrow for textareas
        $("textarea").on("keyup", function () {
            $(this).css("height", "auto");
            $(this).height(this.scrollHeight);
        });
    });
})(this);
